import { getFullUrl } from '../Image/utils/getFullUrl';
import { getImageWidths } from '../Image/utils/getImageWidths';
import { getLargestSize } from '../Image/utils/getLargestSize';
import { getSizesMap } from '../Image/utils/getSizesMap';
import { getSmallestSize } from '../Image/utils/getSmallestSize';
import { getSrcSetFromWidths } from '../Image/utils/getSrcSetFromWidths';
export function constructGallery(images, theme, sizes, aspect, baseUrl) {
    const calculatedSizes = getSizesMap(theme.breakpoints, sizes);
    // Get required set of image widths
    const widths = getImageWidths(theme.breakpoints, sizes);
    return images.map(img => {
        const url = img.url || img.sizes;
        let imageSrc;
        let thumbSrc;
        if (Array.isArray(url)) {
            // maintain support for deprecated image sizes object
            imageSrc = getFullUrl(getLargestSize(url), baseUrl);
            thumbSrc = getFullUrl(getSmallestSize(url), baseUrl);
        }
        else {
            imageSrc = getFullUrl(url, baseUrl);
            thumbSrc = imageSrc;
        }
        // Generate image urls for the required image sizes
        const srcSet = getSrcSetFromWidths(imageSrc, widths, aspect);
        return {
            original: imageSrc,
            originalAlt: img.alt,
            thumbnail: thumbSrc,
            thumbnailAlt: img.alt,
            sizes: calculatedSizes,
            srcSet
        };
    });
}
//# sourceMappingURL=constructGallery.js.map